// src/pages/admin/ActivityLog.jsx
import { useState, useEffect } from "react";
import { fetchActivityLog, ROLE_LABELS } from "../../firebase/auth";
import { B, fonts, Spinner } from "../../components/UI";

const ACTION_ICONS = {
  login:          "🔐",
  logout:         "🚪",
  create_admin:   "➕",
  delete_admin:   "🗑️",
  update_role:    "🔄",
  enable_admin:   "✅",
  disable_admin:  "🚫",
  design_add:     "👗",
  design_edit:    "✏️",
  design_delete:  "🗑️",
  banner_add:     "🖼️",
  category_add:   "📁",
};

const ACTION_COLORS = {
  login:  B.green,  logout: B.textLight,
  create_admin: "#2196F3", delete_admin: B.red,
  update_role: B.gold, enable_admin: B.green, disable_admin: B.red,
  design_add: B.orange, design_delete: B.red,
};

export default function ActivityLog() {
  const [logs,    setLogs]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const l = await fetchActivityLog();
        setLogs(l);
      } catch (e) {
        console.error("Failed to fetch activity log", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const formatTime = (ts) => {
    if (!ts?.toDate) return "—";
    const d = ts.toDate();
    return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div>
      <p style={{ margin: "0 0 12px", fontSize: 12, color: B.textLight, fontFamily: fonts.body }}>Last 50 actions across all admins</p>

      {loading ? <Spinner /> : logs.length === 0
        ? <div style={{ textAlign: "center", padding: 48, color: B.textLight, fontFamily: fonts.body }}>No activity yet.</div>
        : (
          <div style={{ background: B.white, border: `1px solid ${B.borderLight}`, borderRadius: 14, overflow: "hidden" }}>
            {logs.map((log, i) => (
              <div key={log.id}
                style={{ display: "flex", alignItems: "flex-start", gap: 14, padding: "13px 18px", borderBottom: i < logs.length - 1 ? `1px solid ${B.borderLight}` : "none", transition: "background 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.background = B.orangeFaint}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              >
                {/* Icon */}
                <div style={{ width: 36, height: 36, borderRadius: "50%", background: `${ACTION_COLORS[log.action] || B.orange}18`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>
                  {ACTION_ICONS[log.action] || "📝"}
                </div>

                {/* Content */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, color: B.text, fontFamily: fonts.body, marginBottom: 3 }}>
                    <span style={{ fontWeight: 600, color: ACTION_COLORS[log.action] || B.orange, textTransform: "capitalize" }}>
                      {log.action?.replace(/_/g, " ")}
                    </span>
                    {log.detail && <span style={{ color: B.textMid }}> — {log.detail}</span>}
                  </div>
                  <div style={{ fontSize: 11, color: B.textLight, fontFamily: fonts.body }}>
                    UID: {log.uid?.slice(0, 12)}... · {formatTime(log.timestamp)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
}
